import axios from "axios";
import { API_URL } from "../config/endpoints";

export function inviteMember(_id, formData) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}api/sendEmail/${_id}`, formData)
      .then(async (response) => {
        console.log("response.data : ", response.data);
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function inviteNotification(payload){
  return new Promise((resolve,reject)=>{
    axios
    .post(`${API_URL}api/invite`,payload) .then (async(response)=>{
console.log('response data',response);
resolve(response)
      })
      .catch((error)=>{
        reject(error);
      })
  })
}
export function getNotification(data){
  return new Promise((resolve,reject)=>{
    axios.put(`${API_URL}api/getInvite`,data) .then(async(response)=>{
      console.log('response data',response);
      resolve(response)
    })
    .catch((error)=>{
      reject('error',error);
    })
  })
}
export function updateNotification(data){
  return new Promise((resolve,reject)=>{
    axios.put(`${API_URL}api/updateInvite`,data).then(async(response)=>{
      console.log('response data',response);
      resolve(response)
    }).catch(
      (error)=>{
        reject(error);
      }

    )
  })
}